"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Parking;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Parking(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "parking"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.444,71.86a2.5,2.5,0,0,1-2.5-2.5v-38.7a2.5,2.5,0,0,1,2.5-2.5H52.926c.938-.053,7.212-.232,11.417,3.672a12.187,12.187,0,0,1,3.713,9.349c0,6.5-3.528,9.469-6.488,10.82a19.339,19.339,0,0,1-8.007,1.446H40.944V69.36A2.5,2.5,0,0,1,38.444,71.86Zm2.5-23.416h12.61a14.782,14.782,0,0,0,5.938-1c2.431-1.109,3.564-3.1,3.564-6.271a7.322,7.322,0,0,0-2.1-5.669c-2.838-2.656-7.732-2.364-7.78-2.358s-.12.006-.176.006H40.944Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,92.5A42.5,42.5,0,1,1,92.5,50,42.548,42.548,0,0,1,50,92.5Zm0-80A37.5,37.5,0,1,0,87.5,50,37.542,37.542,0,0,0,50,12.5Z"
  })))));
}